module.exports = __webpack_public_path__ + "media/images/icon__burger-menu@3x-cff81abda3118377d7047f651fd8b74f.png";